// Injury toggles (same keys as the athlete's Injuries tab and the backend injury rules). One injury is active at a time
export const injuryOptions = [
    { key: 'patellar-tendon', label: 'Patellar Tendon' },
    { key: 'achilles-tendon', label: 'Achilles Tendon' },
    { key: 'bone-stress', label: 'Bone Stress' },
]
